import "../Css/References.css";
import React from "react";

const references = [
    { name: "Alexander Chatzigeorgiou", job: "Professor", company: "University of Macedonia", email: "achat@uom.gr", url: "https://drive.google.com/file/d/1iqerUxBn7ryigWA3Cs4yAGBhpwuAm2uY/view?usp=sharing" },
    { name: "Vangelis Christou", job: "CTO", company: "Doctoranytime", email: "vchristou@doctoranytime.gr", url: "https://drive.google.com/file/d/1b_z2K7yCUh5XalT7yGrdMtPFFqRZOOLr/view?usp=sharing" },
    { name: "Vasilios Tsiavos", job: "Managing Partner", company: "Neunen IT", email: "info@neunen.com", url: "https://drive.google.com/file/d/18a_SrvBk8hwYA5smt3H4cxyxNJJKAsTr/view?usp=sharing" },
];

const References = () => {

    return (

        <section className="mb-3" id="references">

            <h2 className="section-title">
                <i className="fas fa-envelope-open-text"></i><span style={{ marginLeft: "10px" }}>References</span>
            </h2>

            <div className="references-container cv-grid cv-grid-3">

                {

                    references.map((reference, index) => (

                        <div key={index} className="certification-card reference-card cv-card">

                            <h5 
                                onClick={() => reference.url && window.open(reference.url, "_blank")} 
                                onAuxClick={(e) => {
                                    if (e.button === 1 && reference.url) {
                                        e.preventDefault();
                                        const newWindow = window.open(reference.url, "_blank");
                                        if (newWindow) {
                                            newWindow.blur();
                                            window.focus();
                                        }
                                    }
                                }}
                                onMouseDown={(e) => {
                                    if (e.button === 1 && reference.url) {
                                        e.preventDefault();
                                    }
                                }}
                                style={{ cursor: reference.url ? "pointer" : "default" }}
                            >
                                <span className="certification-text">
                                    <span className="certification-name">{reference.name}</span>
                                    <span className="certification-meta">{reference.job}, {reference.company}</span>
                                </span>
                            </h5>

                            <a className="reference-email" href={`mailto:${reference.email}`}>{reference.email}</a>

                        </div>

                    ))

                }

            </div>

        </section>

    );

};

export default References;